import React, { useState } from 'react';
import './style.scss';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TextField } from '@mui/material';
import Button from '../Shared/components/controls/Button/index';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import config from '../../Config.js';

const SubmitTravelDocuments = (props) => {
  const [refNumber, setRefNumber] = useState(''); // State to store reference number
  const [error, setError] = useState(''); // State to store validation message
  const maxChars = 11; // Character limit
  // Function to dynamically construct the URL
  const getUpdatedLinkUrl = () => {
    const baseLink = props?.fields?.Link?.value?.href || ''; // Get base URL from Sitecore
    return `${baseLink}?RequestId=${refNumber}`;
  };

  // Function to handle link click
  const handleLinkClick = async (e) => {
    try {
      e.preventDefault(); // Prevent default navigation
      // Check if refNumber is empty
      if (!refNumber) {
        setError(props.t('ReferenceNumberRequired')); // Set validation message
        return; // Exit early
      }

      // Validate the reference number
      const isReferenceNumberValid = await validateReferenceNumber();

      if (!isReferenceNumberValid) {
        setError(props.t('RefNumberWrongMsg')); // Set validation message
        return; // Exit early
      }

      // Clear error if validation is successful
      setError('');
      window.location.href = getUpdatedLinkUrl();
    } catch (error) {
      // Handle network or unexpected errors
      e.preventDefault(); // Prevent navigation
      setError(props.t('NetworkError')); // Set a generic network error message
      console.error('Validation failed:', error);
    }
  };

  const validateReferenceNumber = async () => {
    const endpointUrl = `${config.hostname}/api/internationalextensionLimit/GetCardExtensionTripData?RequestId=${refNumber}`;

    try {
      const response = await fetch(endpointUrl);

      // Check if the response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json(); // Parse the JSON response

      // Check the status code in the response
      return data.StatusCode === 200;
    } catch (error) {
      console.error('Error validating reference number:', error);
      return false; // Treat as invalid in case of error
    }
  };
  const handleChange = (e) => {
    const value = e.target.value;

    // Enforce character limit
    if (value.length <= maxChars) {
        setRefNumber(value);
        setError(''); // Clear any error message
    } else {
        setError(`${props.t('Maximum')} ${maxChars} ${props.t('charactersAllowed')}.`);

    }
};

  return (
    <div className="containerCard">
      <div className="CardContianer">
        <div className="container__left">
          <span className="title">
            <Text field={props?.fields?.Title} />
          </span>
          <span className="subTitle">
            <Text field={props?.fields?.Subtitle} />
          </span>
        </div>
        <div className="container__right">
          <TextField
            className="textField"
            id="outlined-basic"
            label={props?.fields?.Label?.value || 'Reference Number'}
            variant="outlined"
            value={refNumber}
            onChange={handleChange}
            error={!!error}
            helperText={error}
          />
          <a href="#" onClick={handleLinkClick} className="button button-contained-primary">
            {props?.fields?.Link?.value?.text || 'Check Now'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(SubmitTravelDocuments));
